import { render, staticRenderFns } from "./ImportAndBalance.vue?vue&type=template&id=0d20a875&"
import script from "./ImportAndBalance.vue?vue&type=script&lang=js&"
export * from "./ImportAndBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports